import { AbstractDTO } from "@signature-it/ngx-generic/models";
import { ProductFieldDisplayType } from '@signature-it/ngx-catalogue/enums';

export class ProductFieldDTO extends AbstractDTO {
    id: number;
    name: string;
    solr_field: string;
    order: number;
    alias: string;
    displayType: string;
    unitName: string;
    icon?: string;
    image?: string;
    sort_option?: string;
    unit_of_measure_mapping?: Array<any>;

    constructor(attributes: object) {
        super(attributes);
        attributes = attributes ? attributes : {};

        this.id = attributes['id'] || -1;
        this.name = attributes['name'] || '';
        this.solr_field = attributes['solr_field'] || '';
        this.order = attributes['order'] || -1;
        this.alias = attributes['alias'] || '';
        this.displayType = attributes['display_type'] || ProductFieldDisplayType.CHECKBOX;
        this.unitName = attributes['unit_name'] || '';
        this.icon = attributes['icon'] || '';
        this.image = attributes['icon'] && attributes['icon'].includes('/') || '';
        this.sort_option = attributes['sort_option'] || '';
        this.unit_of_measure_mapping = attributes['unit_of_measure_mapping'] || null;
    }
}
